<mat-card>
  <mat-card-title>Flights </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div
      fxLayout="row wrap"
      fxLayoutGap="10px"
      fxLayoutAlign="start start"
      [formGroup]="reportParameters"
    >
      <mat-form-field>
        <input matInput formControlName="dispatchId" placeholder="Flight #" />
      </mat-form-field>

      <mat-form-field *ngIf="features.flightTagNumber">
        <input matInput formControlName="flightTagNumber" placeholder="Flight Tag #" />
      </mat-form-field>

      <mat-form-field>
        <input matInput formControlName="tailNumber" placeholder="Tail #" />
      </mat-form-field>

      <mat-form-field>
        <input
          matInput
          formControlName="startTime"
          [matDatepicker]="startPicker"
          placeholder="Start date"
        />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field>
        <input
          matInput
          formControlName="endTime"
          [matDatepicker]="endPicker"
          placeholder="End date"
        />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>

      <ng-container *ngIf="isAviationSupervisor">
        <fl-employee-autocomplete formControlName="employeeId"></fl-employee-autocomplete>
      </ng-container>
      <ng-container *ngIf="isAviationSupervisor">
        <mat-checkbox [formControl]="displayMyFlightsCtrl"> My flights only? </mat-checkbox>
      </ng-container>
      <mat-checkbox formControlName="deleted">Deleted?</mat-checkbox>
      <a mat-button routerLink="/flight-logs">Clear filters</a>
    </div>
    <span *ngIf="(isValidDateRange$ | async) === false" class="validation-error"
      >Please narrow search date range, a maximum of {{ maxNoOfDays }} days is allowed between start
      and end dates</span
    >
    <mat-paginator
      [pageSize]="pageSize$ | async"
      [pageIndex]="pageIndex$ | async"
      [pageSizeOptions]="pageSizeOptions"
      [length]="total$ | async"
      (page)="onPage($event)"
    >
    </mat-paginator>

    <fl-flight-log-highlights-table
      [flightLogs]="flightLogs$"
      [columns]="columns"
      (sort)="onSort($event)"
      (flightLogDeleted)="refresh(2000)"
      (flightLogRestored)="refresh(2000)"
    ></fl-flight-log-highlights-table>
    <mat-paginator
      [pageSize]="pageSize$ | async"
      [pageIndex]="pageIndex$ | async"
      [pageSizeOptions]="pageSizeOptions"
      [length]="total$ | async"
      (page)="onPage($event)"
    >
    </mat-paginator>
    <a mat-button color="primary" (click)="openNewFlightLogDialog()">New Log</a>
  </mat-card-content>
</mat-card>
